import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { RETENTION_STATUSES } from 'components/student-insights/constants'
import { PILL_BADGE_STYLES } from 'lib/styles/pill-badge'
import { REQUEST_STATUS, STATUS_LABELS } from './utils'

const OVERDUE = 'OVERDUE'

// Same small pill and palette as the status chips in "Needs your attention".
const PILLS = {
  [REQUEST_STATUS.PURCHASED]: {
    label: STATUS_LABELS[REQUEST_STATUS.PURCHASED],
    palette: RETENTION_STATUSES.INACTIVE,
  },
  [REQUEST_STATUS.READY_TO_ANALYZE]: {
    label: STATUS_LABELS[REQUEST_STATUS.READY_TO_ANALYZE],
    palette: RETENTION_STATUSES.NEW,
  },
  [REQUEST_STATUS.COMPLETE]: {
    label: STATUS_LABELS[REQUEST_STATUS.COMPLETE],
    palette: RETENTION_STATUSES.ACTIVE,
  },
  [OVERDUE]: { label: 'Overdue', palette: RETENTION_STATUSES.CANCELED },
}

const useStyles = makeStyles({
  pill: { ...PILL_BADGE_STYLES, flexShrink: 0 },
})

const RequestStatusChip = ({ status, overdue = false }) => {
  const classes = useStyles()
  const pill = PILLS[overdue ? OVERDUE : status]

  if (!pill) return null

  return (
    <span
      className={classes.pill}
      style={{
        backgroundColor: pill.palette.background,
        color: pill.palette.color,
      }}
    >
      {pill.label}
    </span>
  )
}

RequestStatusChip.propTypes = {
  status: PropTypes.string,
  overdue: PropTypes.bool,
}

export default RequestStatusChip
